type TWaiter = {
    fileIds: string[]
    resolve: (isDone: boolean) => void
}

const waiters = new Set<TWaiter>()

let uploadingFileIds: string[] = []

const isAnyUploading = (fileIds: string[]) =>
    fileIds.some(fileId => uploadingFileIds.includes(fileId))

export const setUploadingFileIds = (fileIds: string[]) => {
    uploadingFileIds = fileIds

    waiters.forEach(waiter => {
        if (isAnyUploading(waiter.fileIds)) {
            return
        }

        waiters.delete(waiter)
        waiter.resolve(true)
    })
}

export const waitForUploads = (fileIds: string[], signal: AbortSignal): Promise<boolean> =>
    new Promise(resolve => {
        if (signal.aborted) {
            resolve(false)

            return
        }

        if (!isAnyUploading(fileIds)) {
            resolve(true)

            return
        }

        const waiter: TWaiter = { fileIds, resolve }

        waiters.add(waiter)
        signal.addEventListener(
            'abort',
            () => {
                waiters.delete(waiter)
                resolve(false)
            },
            { once: true },
        )
    })
